import intro01T3 from "./Introduccion/Intro-01.mp3";
import intro02T3 from "./Introduccion/Intro-02.mp3";
import intro03T3 from "./Introduccion/Intro-03.mp3";

import sub1_act1_a01T3 from "./Subtema_1/T3-Sub 1- Act 1-A01.mp3";
import sub1_act1_a02T3 from "./Subtema_1/T3-Sub 1- Act 1-A02.mp3";
import sub1_act2_a01T3 from "./Subtema_1/T3-Sub 1- Act 2-A01.mp3";
import sub1_act2_a02T3 from "./Subtema_1/T3-Sub 1- Act 2-A02.mp3";
import sub1_act2_a03T3 from "./Subtema_1/T3-Sub 1- Act 2-A03.mp3";
import sub1_act2_a04T3 from "./Subtema_1/T3-Sub 1- Act 2-A04.mp3";
import sub1_act3_a01T3 from "./Subtema_1/T3-Sub 1- Act 3-A01.mp3";
import sub1_act4_a01T3 from "./Subtema_1/T3-Sub 1- Act 4-A01.mp3";
import sub1_act4_a02T3 from "./Subtema_1/T3-Sub 1- Act 4-A02.mp3";
import sub1_act4_a03T3 from "./Subtema_1/T3-Sub 1- Act 4-A03.mp3";
import sub1_act4_a04T3 from "./Subtema_1/T3-Sub 1- Act 4-A04.mp3";
import sub1_act4_a05T3 from "./Subtema_1/T3-Sub 1- Act 4-A05.mp3";
import sub1_act4_a06T3 from "./Subtema_1/T3-Sub 1- Act 4-A06.mp3";
import sub1_act4_a07T3 from "./Subtema_1/T3-Sub 1- Act 4-A07.mp3";
import sub1_act5_a01T3 from "./Subtema_1/T3-Sub 1- Act 5-A01.mp3";
import sub1_act5_a02T3 from "./Subtema_1/T3-Sub 1- Act 5-A02.mp3";

import sub2_act1_a01T3 from "./Subtema_2/T3-Sub 2- Act 1-A01.mp3";
import sub2_act1_a02T3 from "./Subtema_2/T3-Sub 2- Act 1-A02.mp3";
import sub2_act1_a03T3 from "./Subtema_2/T3-Sub 2- Act 1-A03.mp3";
import sub2_act1_a04T3 from "./Subtema_2/T3-Sub 2- Act 1-A04.mp3";
import sub2_act1_a05T3 from "./Subtema_2/T3-Sub 2- Act 1-A05.mp3";
import sub2_act1_a06T3 from "./Subtema_2/T3-Sub 2- Act 1-A06.mp3";
import sub2_act1_a07T3 from "./Subtema_2/T3-Sub 2- Act 1-A07.mp3";
import sub2_act1_a09T3 from "./Subtema_2/T3-Sub 2- Act 1-A09.mp3";
import sub2_act1_a10T3 from "./Subtema_2/T3-Sub 2- Act 1-A10.mp3";
import sub2_act1_a11T3 from "./Subtema_2/T3-Sub 2- Act 1-A11.mp3";
import sub2_act1_a12T3 from "./Subtema_2/T3-Sub 2- Act 1-A12.mp3";
import sub2_act1_a13T3 from "./Subtema_2/T3-Sub 2- Act 1-A13.mp3";
import sub2_act2_a01T3 from "./Subtema_2/T3-Sub 2- Act 2-A01.mp3";
import sub2_act3_a01T3 from "./Subtema_2/T3-Sub 2- Act 3-A01.mp3";
import sub2_act3_a02T3 from "./Subtema_2/T3-Sub 2- Act 3-A02.mp3";
import sub2_act3_a03T3 from "./Subtema_2/T3-Sub 2- Act 3-A03.mp3";
import sub2_act4_a01T3 from "./Subtema_2/T3-Sub 2- Act 4-A01.mp3";
import sub2_act4_a02T3 from "./Subtema_2/T3-Sub 2- Act 4-A02.mp3";
import sub2_act4_a03T3 from "./Subtema_2/T3-Sub 2- Act 4-A03.mp3";
import sub2_act4_a04T3 from "./Subtema_2/T3-Sub 2- Act 4-A04.mp3";
import sub2_act4_a05T3 from "./Subtema_2/T3-Sub 2- Act 4-A05.mp3";
import sub2_act5_a01T3 from "./Subtema_2/T3-Sub 2- Act 5-A01.mp3";
import sub2_act5_a02T3 from "./Subtema_2/T3-Sub 2- Act 5-A02.mp3";
import sub2_act5_a03T3 from "./Subtema_2/T3-Sub 2- Act 5-A03.mp3";
import sub2_act5_a04T3 from "./Subtema_2/T3-Sub 2- Act 5-A04.mp3";
import sub2_act5_a05T3 from "./Subtema_2/T3-Sub 2- Act 5-A05.mp3";
import sub2_act5_a06T3 from "./Subtema_2/T3-Sub 2- Act 5-A06.mp3";
import sub2_act5_a07T3 from "./Subtema_2/T3-Sub 2- Act 5-A07.mp3";
import sub2_act5_a08T3 from "./Subtema_2/T3-Sub 2- Act 5-A08.mp3";
import sub2_act5_a09T3 from "./Subtema_2/T3-Sub 2- Act 5-A09.mp3";
import sub2_act5_a10T3 from "./Subtema_2/T3-Sub 2- Act 5-A10.mp3";
import sub2_act5_a11T3 from "./Subtema_2/T3-Sub 2- Act 5-A11.mp3";
import sub2_act5_a12T3 from "./Subtema_2/T3-Sub 2- Act 5-A12.mp3";
import sub2_act5_a13T3 from "./Subtema_2/T3-Sub 2- Act 5-A13.mp3";
import sub2_act5_a14T3 from "./Subtema_2/T3-Sub 2- Act 5-A14.mp3";
import sub2_act5_a15T3 from "./Subtema_2/T3-Sub 2- Act 5-A15.mp3";
import sub2_act5_a16T3 from "./Subtema_2/T3-Sub 2- Act 5-A16.mp3";
import sub2_act5_a17T3 from "./Subtema_2/T3-Sub 2- Act 5-A17.mp3";

import sub3_act1_a01T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A01.mp3";
import sub3_act1_a02T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A02.mp3";
import sub3_act1_a03T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A03.mp3";
import sub3_act1_a04T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A04.mp3";
import sub3_act1_a05T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A05.mp3";
import sub3_act1_a06T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A06.mp3";
import sub3_act1_a07T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A07.mp3";
import sub3_act1_a08T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A08.mp3";
import sub3_act1_a09T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A09.mp3";
import sub3_act1_a10T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A10.mp3";
import sub3_act1_a11T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A11.mp3";
import sub3_act1_a12T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A12.mp3";
import sub3_act1_a13T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A13.mp3";
import sub3_act1_a14T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A14.mp3";
import sub3_act1_a15T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A15.mp3";
import sub3_act1_a16T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A16.mp3";
import sub3_act1_a17T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A17.mp3";
import sub3_act1_a18T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A18.mp3";
import sub3_act1_a19T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A19.mp3";
import sub3_act1_a20T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A20.mp3";
import sub3_act1_a21T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A21.mp3";
import sub3_act1_a22T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A22.mp3";
import sub3_act1_a23T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A23.mp3";
import sub3_act1_a24T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A24.mp3";
import sub3_act1_a25T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A25.mp3";
import sub3_act1_a26T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A26.mp3";
import sub3_act1_a27T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A27.mp3";
import sub3_act1_a28T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A28.mp3";
import sub3_act1_a29T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A29.mp3";
import sub3_act1_a30T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A30.mp3";
import sub3_act1_a31T3 from "./Subtema_3/Actividad-1/T3-Sub 3- Act 1-A31.mp3";

import sub3_act2_a01T3 from "./Subtema_3/Actividad-2/T3-Sub 3- Act 2-A01.mp3";


import sub3_act3_a01T3 from "./Subtema_3/Actividad-3/T3-Sub 3- Act 3-A01.mp3";
import sub3_act3_a02T3 from "./Subtema_3/Actividad-3/T3-Sub 3- Act 3-A02.mp3";
import sub3_act3_a03T3 from "./Subtema_3/Actividad-3/T3-Sub 3- Act 3-A03.mp3";
import sub3_act3_a04T3 from "./Subtema_3/Actividad-3/T3-Sub 3- Act 3-A04.mp3";
import sub3_act3_a05T3 from "./Subtema_3/Actividad-3/T3-Sub 3- Act 3-A05.mp3";
import sub3_act3_a06T3 from "./Subtema_3/Actividad-3/T3-Sub 3- Act 3-A06.mp3";
import sub3_act3_a07T3 from "./Subtema_3/Actividad-3/T3-Sub 3- Act 3-A07.mp3";
import sub3_act3_a08T3 from "./Subtema_3/Actividad-3/T3-Sub 3- Act 3-A08.mp3";
import sub3_act3_a09T3 from "./Subtema_3/Actividad-3/T3-Sub 3- Act 3-A09.mp3";
import sub3_act3_a10T3 from "./Subtema_3/Actividad-3/T3-Sub 3- Act 3-A10.mp3";

import sub3_act4_a01T3 from "./Subtema_3/Actividad-4/T3-Sub 3- Act 4-A01.mp3";
import sub3_act4_a02T3 from "./Subtema_3/Actividad-4/T3-Sub 3- Act 4-A02.mp3";



export const T3_voices = {
	introduccion: {
		intro01T3,
		intro02T3,
		intro03T3,
	},
	subtema_1: {
		sub1_act1_a01T3,
		sub1_act1_a02T3,
		sub1_act2_a01T3,
		sub1_act2_a02T3,
		sub1_act2_a03T3,
		sub1_act2_a04T3,
		sub1_act3_a01T3,
		sub1_act4_a01T3,
		sub1_act4_a02T3,
		sub1_act4_a03T3,
		sub1_act4_a04T3,
		sub1_act4_a05T3,
		sub1_act4_a06T3,
		sub1_act4_a07T3,
		sub1_act5_a01T3,
		sub1_act5_a02T3,
	},
	subtema_2: {
		sub2_act1_a01T3,
		sub2_act1_a02T3,
		sub2_act1_a03T3,
		sub2_act1_a04T3,
		sub2_act1_a05T3,
		sub2_act1_a06T3,
		sub2_act1_a07T3,
		sub2_act1_a09T3,
		sub2_act1_a10T3,
		sub2_act1_a11T3,
		sub2_act1_a12T3,
		sub2_act1_a13T3,
		sub2_act2_a01T3,
		sub2_act3_a01T3,
		sub2_act3_a02T3,
		sub2_act3_a03T3,
		sub2_act4_a01T3,
		sub2_act4_a02T3,
		sub2_act4_a03T3,
		sub2_act4_a04T3,
		sub2_act4_a05T3,
		sub2_act5_a01T3,
		sub2_act5_a02T3,
		sub2_act5_a03T3,
		sub2_act5_a04T3,
		sub2_act5_a05T3,
		sub2_act5_a06T3,
		sub2_act5_a07T3,
		sub2_act5_a08T3,
		sub2_act5_a09T3,
		sub2_act5_a10T3,
		sub2_act5_a11T3,
		sub2_act5_a12T3,
		sub2_act5_a13T3,
		sub2_act5_a14T3,
		sub2_act5_a15T3,
		sub2_act5_a16T3,
		sub2_act5_a17T3,
	},
	subtema_3: {
		actividad_1: {
			sub3_act1_a01T3,
			sub3_act1_a02T3,
			sub3_act1_a03T3,
			sub3_act1_a04T3,
			sub3_act1_a05T3,
			sub3_act1_a06T3,
			sub3_act1_a07T3,
			sub3_act1_a08T3,
			sub3_act1_a09T3,
			sub3_act1_a10T3,
			sub3_act1_a11T3,
			sub3_act1_a12T3,
			sub3_act1_a13T3,
			sub3_act1_a14T3,
			sub3_act1_a15T3,
			sub3_act1_a16T3,
			sub3_act1_a17T3,
			sub3_act1_a18T3,
			sub3_act1_a19T3,
			sub3_act1_a20T3,
			sub3_act1_a21T3,
			sub3_act1_a22T3,
			sub3_act1_a23T3,
			sub3_act1_a24T3,
			sub3_act1_a25T3,
			sub3_act1_a26T3,
			sub3_act1_a27T3,
			sub3_act1_a28T3,
			sub3_act1_a29T3,
			sub3_act1_a30T3,
			sub3_act1_a31T3,
		},
		actividad_2: {
			sub3_act2_a01T3,
		},
		actividad_3: {
			sub3_act3_a01T3,
			sub3_act3_a02T3,
			sub3_act3_a03T3,
			sub3_act3_a04T3,
			sub3_act3_a05T3,
			sub3_act3_a06T3,
			sub3_act3_a07T3,
			sub3_act3_a08T3,
			sub3_act3_a09T3,
			sub3_act3_a10T3,
		},
		actividad_4: {
			sub3_act4_a01T3,
			sub3_act4_a02T3,
		},
	},
};
